export default function(serviceConstructor) {
  if (!serviceConstructor.__instance)
    serviceConstructor.__instance = new serviceConstructor()
  return serviceConstructor.__instance
}



// WEBPACK FOOTER //
// ./src/helpers/inject.js